import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n/index.jsx';
import { useAuth } from '../auth.jsx';
import { useChat } from '../chat/ChatProvider.jsx';
import Logo from './Logo.jsx';
import { useTeam } from '../team.js';

// Public pages in the main nav.
const NAV = [
  { to: '/', key: 'nav.home', end: true },
  { to: '/marketplace', key: 'nav.marketplace' },
  { to: '/news', key: 'nav.news' },
  { to: '/about', key: 'nav.about' },
  { to: '/contact', key: 'nav.contact' },
];

export function LangSwitch() {
  const { lang, setLang, t } = useI18n();
  return (
    <div className="lang-switch" translate="no" role="group" aria-label={t('nav.language')}>
      {['fr', 'en'].map((l) => (
        <button key={l} type="button" className={lang === l ? 'active' : ''} aria-pressed={lang === l} onClick={() => setLang(l)}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export default function Header() {
  const { t, lang } = useI18n();
  // "Team" tab: once the team page is published with its tab turned on.
  const { inMenu } = useTeam();
  const nav = inMenu ? [...NAV.slice(0, 4), { to: lang === 'en' ? '/team' : '/equipe', key: 'nav.team' }, ...NAV.slice(4)] : NAV;
  const { user, signOut } = useAuth();
  const { unread: chatUnread } = useChat();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const logout = () => {
    signOut();
    navigate('/');
  };

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" aria-label={t('brand.name')}>
          <Logo />
          <span translate="no">{t('brand.name')}</span>
        </Link>

        <button type="button" className="menu-toggle" aria-expanded={open} aria-controls="site-nav" onClick={() => setOpen((o) => !o)}>
          <span className="sr-only">{t('nav.menu')}</span>
          <span className="menu-bars" aria-hidden="true" />
        </button>

        <div id="site-nav" className={`header-nav ${open ? 'open' : ''}`}>
          <nav className="nav-links">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end}>{t(n.key)}</NavLink>
            ))}
          </nav>
          <div className="header-actions">
            <LangSwitch />
            {user ? (
              <>
                {user.role === 'admin' && <Link className="btn btn-ghost btn-sm" to="/admin">{t('nav.admin')}</Link>}
                <Link className="btn btn-ghost btn-sm header-account" to={chatUnread && user.role !== 'admin' ? '/account/messages' : '/account'}
                  aria-label={chatUnread && user.role !== 'admin' ? `${t('nav.account')} — ${t('chat.unreadN', { n: chatUnread })}` : undefined}>
                  {t('nav.account')}
                  {chatUnread > 0 && user.role !== 'admin' && <span className="header-badge" aria-hidden="true">{chatUnread > 99 ? '99+' : chatUnread}</span>}
                </Link>
                <button type="button" className="btn btn-link btn-sm" onClick={logout}>{t('nav.logout')}</button>
              </>
            ) : (
              <>
                <Link className="btn btn-ghost btn-sm" to="/login">{t('nav.login')}</Link>
                <Link className="btn btn-primary btn-sm" to="/signup">{t('nav.signup')}</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
